var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopDesktopLandingPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1437,
    height: 518,
    opacity: 0.6,
    viewBox: "0 0 1437 518",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8398 200.85C0.839846 234.54 -6.73015 276.61 7.76985 308.29C37.3598 372.91 123.89 386.13 168.01 331.4C181.49 314.67 194.98 295.94 215.32 289.03C253.27 276.15 291.88 297.81 330.26 277.58C371.16 256.02 399.93 211.46 447.65 203.1C476.57 198.03 502.67 208.84 530.38 205.88C544.18 204.41 558.37 201.3 569.3 192.75C598.07 170.23 591.47 123.95 573.77 97.33C559.88 76.45 539.09 60.74 516.29 50.28C464.41 26.47 405.31 39.05 350.88 45.86C318.26 49.94 286.94 56.51 254.48 60.61C218.37 65.16 182.4 72.39 148.3 85.37C101.93 103.01 58.7498 132.04 31.0298 173.19C25.5598 181.31 20.3598 190.7 15.8398 200.86V200.85Z",
    fill: "#67CFEE"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1044.3 188.242C1045.25 185.262 1045.96 182.232 1046.44 179.162L1040.83 184.772L1030.18 195.422L1019.53 206.072L1008.88 216.722L998.23 227.372L995.92 229.682C997.22 229.482 998.52 229.232 999.81 228.952C1003.61 228.102 1007.34 226.892 1010.95 225.302L1014.2 222.052L1024.85 211.402L1035.5 200.752L1042.04 194.202C1042.9 192.252 1043.65 190.262 1044.29 188.252L1044.3 188.242Z",
    fill: "#FFDE00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1040.83 163.482L1030.18 174.132L1019.53 184.782L1008.88 195.432L998.23 206.082L987.58 216.732L976.93 227.382L975 229.312C976.52 229.602 978.04 229.832 979.57 230.012C981.23 230.202 982.9 230.322 984.57 230.382L992.9 222.052L1003.55 211.402L1014.2 200.752L1024.85 190.102L1035.5 179.452L1046.15 168.802L1047.13 167.822C1047.03 164.612 1046.67 161.412 1046.06 158.242L1040.83 163.472V163.482Z",
    fill: "#FFDE00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1030.19 152.842L1019.54 163.492L1008.89 174.142L998.24 184.792L987.59 195.442L976.94 206.092L966.29 216.742L959.14 223.892C961.57 225.122 964.06 226.182 966.61 227.072L971.61 222.072L982.26 211.422L992.91 200.772L1003.56 190.122L1014.21 179.472L1024.86 168.822L1035.51 158.172L1043.81 149.872C1042.93 147.332 1041.87 144.832 1040.63 142.402L1030.19 152.842Z",
    fill: "#FFDE00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1030.19 131.552L1019.54 142.202L1008.89 152.852L998.24 163.502L987.59 174.152L976.94 184.802L966.29 195.452L955.64 206.102L946.46 215.282C948.38 216.982 950.38 218.532 952.45 219.942L960.96 211.432L971.61 200.782L982.26 190.132L992.91 179.482L1003.56 168.832L1014.21 158.182L1024.86 147.532L1035.51 136.882L1036.67 135.722C1035.26 133.652 1033.71 131.652 1032.01 129.732L1030.18 131.562L1030.19 131.552Z",
    fill: "#FFDE00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.54 120.902L1008.89 131.552L998.24 142.202L987.59 152.852L976.94 163.502L966.29 174.152L955.64 184.802L944.99 195.452L936.47 203.972C937.88 206.042 939.44 208.032 941.13 209.952L950.31 200.772L960.96 190.122L971.61 179.472L982.26 168.822L992.91 158.172L1003.56 147.522L1014.21 136.872L1024.86 126.222L1026.69 124.392C1024.77 122.692 1022.78 121.142 1020.71 119.732L1019.54 120.902Z",
    fill: "#FFDE00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M998.25 120.902L987.6 131.552L976.95 142.202L966.3 152.852L955.65 163.502L945 174.152L934.35 184.802L929.33 189.822C930.22 192.362 931.28 194.852 932.51 197.282L939.67 190.122L950.32 179.472L960.97 168.822L971.62 158.172L982.27 147.522L992.92 136.872L1003.57 126.222L1014.03 115.762C1011.6 114.532 1009.11 113.462 1006.57 112.582L998.25 120.902Z",
    fill: "#FFDE00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M987.61 110.262L976.96 120.912L966.31 131.562L955.66 142.212L945.01 152.862L934.36 163.512L926 171.872C926.06 173.522 926.18 175.162 926.36 176.802C926.54 178.352 926.78 179.902 927.07 181.442L929.03 179.482L939.68 168.832L950.33 158.182L960.98 147.532L971.63 136.882L982.28 126.232L992.93 115.582L998.19 110.322C995.03 109.712 991.83 109.352 988.62 109.242L987.61 110.252V110.262Z",
    fill: "#FFDE00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M962.32 114.252L955.67 120.902L945.02 131.552L934.37 142.202L931.02 145.552C929.46 149.122 928.27 152.802 927.43 156.552C927.14 157.872 926.89 159.202 926.68 160.532L929.04 158.172L939.69 147.522L950.34 136.872L960.99 126.222L971.64 115.572L977.3 109.912C974.2 110.392 971.14 111.102 968.13 112.062C966.17 112.692 964.23 113.412 962.32 114.242V114.252Z",
    fill: "#FFDE00"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M482.17 214.162C480.06 216.272 480.03 219.662 482.07 221.812C483.79 218.802 485.34 215.732 486.74 212.602C485.11 212.392 483.41 212.912 482.16 214.162H482.17Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M474.41 229.682C472.27 227.542 468.8 227.542 466.65 229.682C464.51 231.822 464.51 235.302 466.65 237.442C467.56 238.352 468.7 238.872 469.89 239.002C471.94 236.632 473.88 234.202 475.69 231.702C475.42 230.962 475 230.272 474.41 229.672V229.682Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M458.89 245.202C456.75 243.062 453.28 243.062 451.13 245.202C448.99 247.342 448.99 250.822 451.13 252.962C451.81 253.642 452.63 254.112 453.5 254.352C455.88 252.542 458.21 250.622 460.47 248.592C460.36 247.352 459.83 246.142 458.88 245.202H458.89Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M443.37 260.722C441.23 258.582 437.76 258.582 435.61 260.722C434.17 262.162 433.7 264.192 434.2 266.022C437.41 264.522 440.56 262.852 443.64 261.012C443.55 260.912 443.47 260.812 443.37 260.722Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M496.1 171.722C496.1 171.442 496.12 171.172 496.12 170.892C496.09 171.172 496.08 171.442 496.1 171.722Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M482.17 183.122C480.03 185.262 480.03 188.742 482.17 190.882C484.31 193.022 487.79 193.022 489.93 190.882C492.07 188.742 492.07 185.262 489.93 183.122C487.79 180.982 484.32 180.982 482.17 183.122Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M466.65 198.642C464.51 200.782 464.51 204.262 466.65 206.402C468.79 208.542 472.27 208.542 474.41 206.402C476.55 204.262 476.55 200.782 474.41 198.642C472.27 196.502 468.8 196.502 466.65 198.642Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M451.13 214.162C448.99 216.302 448.99 219.782 451.13 221.922C453.27 224.062 456.75 224.062 458.89 221.922C461.03 219.782 461.03 216.302 458.89 214.162C456.75 212.022 453.28 212.022 451.13 214.162Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M435.61 229.682C433.47 231.822 433.47 235.302 435.61 237.442C437.75 239.582 441.23 239.582 443.37 237.442C445.51 235.302 445.51 231.822 443.37 229.682C441.23 227.542 437.76 227.542 435.61 229.682Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M420.09 245.202C417.95 247.342 417.95 250.822 420.09 252.962C422.23 255.102 425.71 255.102 427.85 252.962C429.99 250.822 429.99 247.342 427.85 245.202C425.71 243.062 422.24 243.062 420.09 245.202Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M404.57 260.722C402.43 262.862 402.43 266.342 404.57 268.482C406.71 270.622 410.19 270.622 412.33 268.482C414.47 266.342 414.47 262.862 412.33 260.722C410.18 258.582 406.72 258.582 404.57 260.722Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M389.16 276.142C391.57 276.132 393.99 276.042 396.4 275.862C394.28 274.132 391.18 274.222 389.16 276.142Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M489.93 152.082C487.79 149.942 484.32 149.942 482.17 152.082C480.03 154.222 480.03 157.702 482.17 159.842C484.31 161.982 487.79 161.982 489.93 159.842C492.07 157.702 492.07 154.222 489.93 152.082Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M474.41 167.602C472.27 165.462 468.8 165.462 466.65 167.602C464.51 169.742 464.51 173.222 466.65 175.362C468.79 177.502 472.27 177.502 474.41 175.362C476.55 173.222 476.55 169.742 474.41 167.602Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M458.89 183.122C456.75 180.982 453.28 180.982 451.13 183.122C448.99 185.262 448.99 188.742 451.13 190.882C453.27 193.022 456.75 193.022 458.89 190.882C461.03 188.742 461.03 185.262 458.89 183.122Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M443.37 198.642C441.23 196.502 437.76 196.502 435.61 198.642C433.47 200.782 433.47 204.262 435.61 206.402C437.75 208.542 441.23 208.542 443.37 206.402C445.51 204.262 445.51 200.782 443.37 198.642Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M427.85 214.162C425.71 212.022 422.24 212.022 420.09 214.162C417.95 216.302 417.95 219.782 420.09 221.922C422.23 224.062 425.71 224.062 427.85 221.922C429.99 219.782 429.99 216.302 427.85 214.162Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M412.33 229.682C410.18 227.542 406.72 227.542 404.57 229.682C402.43 231.822 402.43 235.302 404.57 237.442C406.71 239.582 410.19 239.582 412.33 237.442C414.47 235.302 414.47 231.822 412.33 229.682Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M389.05 245.202C386.91 247.342 386.91 250.822 389.05 252.962C391.2 255.102 394.67 255.102 396.81 252.962C398.95 250.822 398.95 247.342 396.81 245.202C394.67 243.062 391.2 243.062 389.05 245.202Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M373.53 260.722C371.39 262.862 371.39 266.342 373.53 268.482C375.67 270.622 379.15 270.622 381.29 268.482C383.43 266.342 383.43 262.862 381.29 260.722C379.15 258.582 375.68 258.582 373.53 260.722Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M482.17 128.802C483.99 130.622 486.76 130.892 488.87 129.622C487.56 126.252 486.08 122.932 484.42 119.682C483.6 119.942 482.82 120.392 482.17 121.042C480.03 123.182 480.03 126.662 482.17 128.802Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M474.41 136.562C472.27 134.422 468.8 134.422 466.65 136.562C464.51 138.702 464.51 142.182 466.65 144.322C468.79 146.462 472.27 146.462 474.41 144.322C476.55 142.182 476.55 138.702 474.41 136.562Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M458.89 152.082C456.75 149.942 453.28 149.942 451.13 152.082C448.99 154.222 448.99 157.702 451.13 159.842C453.27 161.982 456.75 161.982 458.89 159.842C461.03 157.702 461.03 154.222 458.89 152.082Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M443.37 167.602C441.23 165.462 437.76 165.462 435.61 167.602C433.47 169.742 433.47 173.222 435.61 175.362C437.75 177.502 441.23 177.502 443.37 175.362C445.51 173.222 445.51 169.742 443.37 167.602Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M427.85 183.122C425.71 180.982 422.24 180.982 420.09 183.122C417.95 185.262 417.95 188.742 420.09 190.882C422.23 193.022 425.71 193.022 427.85 190.882C429.99 188.742 429.99 185.262 427.85 183.122Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M412.33 198.642C410.18 196.502 406.72 196.502 404.57 198.642C402.43 200.782 402.43 204.262 404.57 206.402C406.71 208.542 410.19 208.542 412.33 206.402C414.47 204.262 414.47 200.782 412.33 198.642Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M396.81 214.162C394.67 212.022 391.2 212.022 389.05 214.162C386.91 216.302 386.91 219.782 389.05 221.922C391.2 224.062 394.67 224.062 396.81 221.922C398.95 219.782 398.95 216.302 396.81 214.162Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M381.29 229.682C379.15 227.542 375.68 227.542 373.53 229.682C371.39 231.822 371.39 235.302 373.53 237.442C375.67 239.582 379.15 239.582 381.29 237.442C383.43 235.302 383.43 231.822 381.29 229.682Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M358.01 245.202C355.87 247.342 355.87 250.822 358.01 252.962C360.15 255.102 363.63 255.102 365.77 252.962C367.91 250.822 367.91 247.342 365.77 245.202C363.63 243.062 360.16 243.062 358.01 245.202Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M350.26 268.482C352.4 266.342 352.4 262.862 350.26 260.722C348.12 258.582 344.65 258.582 342.5 260.722C341.31 261.912 340.79 263.502 340.91 265.052C343.81 266.482 346.76 267.772 349.75 268.922C349.93 268.782 350.1 268.642 350.26 268.472V268.482Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M474.41 105.522C472.27 103.382 468.8 103.382 466.65 105.522C464.51 107.662 464.51 111.142 466.65 113.282C468.79 115.422 472.27 115.422 474.41 113.282C476.55 111.142 476.55 107.662 474.41 105.522Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M458.89 121.042C456.75 118.902 453.28 118.902 451.13 121.042C448.99 123.182 448.99 126.662 451.13 128.802C453.27 130.942 456.75 130.942 458.89 128.802C461.03 126.662 461.03 123.182 458.89 121.042Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M443.37 136.562C441.23 134.422 437.76 134.422 435.61 136.562C433.47 138.702 433.47 142.182 435.61 144.322C437.75 146.462 441.23 146.462 443.37 144.322C445.51 142.182 445.51 138.702 443.37 136.562Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M427.85 152.082C425.71 149.942 422.24 149.942 420.09 152.082C417.95 154.222 417.95 157.702 420.09 159.842C422.23 161.982 425.71 161.982 427.85 159.842C429.99 157.702 429.99 154.222 427.85 152.082Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M412.33 167.602C410.19 165.462 406.72 165.462 404.57 167.602C402.43 169.742 402.43 173.222 404.57 175.362C406.71 177.502 410.19 177.502 412.33 175.362C414.47 173.222 414.47 169.742 412.33 167.602Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M396.81 183.122C394.67 180.982 391.2 180.982 389.05 183.122C386.91 185.262 386.91 188.742 389.05 190.882C391.2 193.022 394.67 193.022 396.81 190.882C398.95 188.742 398.95 185.262 396.81 183.122Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M381.29 198.642C379.15 196.502 375.68 196.502 373.53 198.642C371.39 200.782 371.39 204.262 373.53 206.402C375.67 208.542 379.15 208.542 381.29 206.402C383.43 204.262 383.43 200.782 381.29 198.642Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M365.77 214.162C363.63 212.022 360.16 212.022 358.01 214.162C355.87 216.302 355.87 219.782 358.01 221.922C360.15 224.062 363.63 224.062 365.77 221.922C367.91 219.782 367.91 216.302 365.77 214.162Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M342.5 229.682C340.36 231.822 340.36 235.302 342.5 237.442C344.64 239.582 348.11 239.582 350.26 237.442C352.4 235.302 352.4 231.822 350.26 229.682C348.12 227.542 344.65 227.542 342.5 229.682Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M326.97 245.202C324.83 247.342 324.83 250.822 326.97 252.962C329.11 255.102 332.59 255.102 334.73 252.962C336.87 250.822 336.87 247.342 334.73 245.202C332.59 243.062 329.12 243.062 326.97 245.202Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M458.89 90.002C456.75 87.862 453.28 87.862 451.13 90.002C448.99 92.142 448.99 95.622 451.13 97.762C453.27 99.902 456.75 99.902 458.89 97.762C461.03 95.612 461.03 92.142 458.89 90.002Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M443.37 105.522C441.23 103.382 437.76 103.382 435.61 105.522C433.47 107.662 433.47 111.142 435.61 113.282C437.75 115.422 441.23 115.422 443.37 113.282C445.51 111.142 445.51 107.662 443.37 105.522Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M427.85 121.042C425.71 118.902 422.24 118.902 420.09 121.042C417.95 123.182 417.95 126.662 420.09 128.802C422.23 130.942 425.71 130.942 427.85 128.802C429.99 126.662 429.99 123.182 427.85 121.042Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M412.33 136.562C410.19 134.422 406.72 134.422 404.57 136.562C402.43 138.702 402.43 142.182 404.57 144.322C406.71 146.462 410.19 146.462 412.33 144.322C414.47 142.182 414.47 138.702 412.33 136.562Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M396.81 152.082C394.67 149.942 391.2 149.942 389.05 152.082C386.91 154.222 386.91 157.702 389.05 159.842C391.2 161.982 394.67 161.982 396.81 159.842C398.95 157.702 398.95 154.222 396.81 152.082Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M381.29 167.602C379.15 165.462 375.68 165.462 373.53 167.602C371.39 169.742 371.39 173.222 373.53 175.362C375.67 177.502 379.15 177.502 381.29 175.362C383.43 173.222 383.43 169.742 381.29 167.602Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M365.77 183.122C363.63 180.982 360.16 180.982 358.01 183.122C355.86 185.262 355.86 188.742 358.01 190.882C360.15 193.022 363.63 193.022 365.77 190.882C367.91 188.742 367.91 185.262 365.77 183.122Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M350.25 198.642C348.11 196.502 344.64 196.502 342.49 198.642C340.35 200.782 340.35 204.262 342.49 206.402C344.63 208.542 348.1 208.542 350.25 206.402C352.39 204.262 352.39 200.782 350.25 198.642Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M334.73 214.162C332.59 212.022 329.12 212.022 326.97 214.162C324.83 216.302 324.83 219.782 326.97 221.922C329.11 224.062 332.59 224.062 334.73 221.922C336.87 219.782 336.87 216.302 334.73 214.162Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M311.45 229.682C309.31 231.822 309.31 235.302 311.45 237.442C313.59 239.582 317.07 239.582 319.21 237.442C321.35 235.302 321.35 231.822 319.21 229.682C317.07 227.542 313.6 227.542 311.45 229.682Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M435.61 82.2519C437.75 84.3919 441.23 84.3919 443.37 82.2519C444.84 80.7819 445.3 78.6719 444.75 76.8119C442.58 75.4819 440.37 74.2319 438.12 73.0619C437.2 73.3019 436.33 73.7719 435.61 74.4919C433.47 76.6319 433.47 80.1119 435.61 82.2519Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M427.85 90.012C425.71 87.872 422.24 87.872 420.09 90.012C417.95 92.152 417.95 95.632 420.09 97.772C422.23 99.912 425.71 99.912 427.85 97.772C429.99 95.632 429.99 92.152 427.85 90.012Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M412.33 105.522C410.19 103.382 406.72 103.382 404.57 105.522C402.43 107.662 402.43 111.142 404.57 113.282C406.71 115.422 410.19 115.422 412.33 113.282C414.47 111.142 414.47 107.662 412.33 105.522Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M396.81 121.042C394.67 118.902 391.2 118.902 389.05 121.042C386.91 123.182 386.91 126.662 389.05 128.802C391.2 130.942 394.67 130.942 396.81 128.802C398.95 126.662 398.95 123.182 396.81 121.042Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M381.29 136.562C379.15 134.422 375.68 134.422 373.53 136.562C371.39 138.702 371.39 142.182 373.53 144.322C375.67 146.462 379.15 146.462 381.29 144.322C383.43 142.182 383.43 138.702 381.29 136.562Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M365.77 152.082C363.63 149.942 360.16 149.942 358.01 152.082C355.86 154.222 355.86 157.702 358.01 159.842C360.15 161.982 363.63 161.982 365.77 159.842C367.91 157.702 367.91 154.222 365.77 152.082Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M350.25 167.602C348.11 165.462 344.64 165.462 342.49 167.602C340.35 169.742 340.35 173.222 342.49 175.362C344.63 177.502 348.1 177.502 350.25 175.362C352.39 173.222 352.39 169.742 350.25 167.602Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M334.73 183.122C332.59 180.982 329.12 180.982 326.97 183.122C324.83 185.262 324.83 188.742 326.97 190.882C329.11 193.022 332.59 193.022 334.73 190.882C336.87 188.742 336.87 185.262 334.73 183.122Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M319.21 198.642C317.07 196.502 313.6 196.502 311.45 198.642C309.31 200.782 309.31 204.262 311.45 206.402C313.59 208.542 317.07 208.542 319.21 206.402C321.35 204.262 321.35 200.782 319.21 198.642Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M295.94 214.162C293.8 216.302 293.8 219.782 295.94 221.922C298.08 224.062 301.56 224.062 303.7 221.922C305.84 219.782 305.84 216.302 303.7 214.162C301.56 212.022 298.09 212.022 295.94 214.162Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M420.09 66.7319C421.77 68.4119 424.28 68.7718 426.31 67.8118C423.93 66.9218 421.53 66.1219 419.11 65.4019C419.36 65.8819 419.69 66.3319 420.09 66.7319Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M412.33 74.4919C410.19 72.3419 406.72 72.3419 404.57 74.4919C402.43 76.6319 402.43 80.1119 404.57 82.2519C406.71 84.3919 410.19 84.3919 412.33 82.2519C414.47 80.1119 414.47 76.6319 412.33 74.4919Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M396.81 90.012C394.67 87.872 391.2 87.872 389.05 90.012C386.91 92.152 386.91 95.632 389.05 97.772C391.2 99.912 394.67 99.912 396.81 97.772C398.95 95.632 398.95 92.152 396.81 90.012Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M381.29 105.522C379.15 103.382 375.68 103.382 373.53 105.522C371.39 107.662 371.39 111.142 373.53 113.282C375.67 115.422 379.15 115.422 381.29 113.282C383.43 111.142 383.43 107.662 381.29 105.522Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M365.77 121.042C363.63 118.902 360.16 118.902 358.01 121.042C355.86 123.182 355.86 126.662 358.01 128.802C360.15 130.942 363.63 130.942 365.77 128.802C367.91 126.662 367.91 123.182 365.77 121.042Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M350.25 136.562C348.11 134.422 344.64 134.422 342.49 136.562C340.35 138.702 340.35 142.182 342.49 144.322C344.63 146.462 348.1 146.462 350.25 144.322C352.39 142.182 352.39 138.702 350.25 136.562Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M334.73 152.092C332.59 149.952 329.12 149.952 326.97 152.092C324.83 154.232 324.83 157.712 326.97 159.852C329.11 161.992 332.59 161.992 334.73 159.852C336.87 157.712 336.87 154.232 334.73 152.092Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M319.22 167.602C317.08 165.462 313.61 165.462 311.46 167.602C309.32 169.742 309.32 173.222 311.46 175.362C313.6 177.502 317.08 177.502 319.22 175.362C321.36 173.222 321.36 169.742 319.22 167.602Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M303.69 183.122C301.55 180.982 298.08 180.982 295.93 183.122C293.79 185.262 293.79 188.742 295.93 190.882C298.07 193.022 301.55 193.022 303.69 190.882C305.83 188.742 305.83 185.262 303.69 183.122Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M288.18 198.642C287.24 197.702 286.04 197.172 284.82 197.062C285.7 200.292 286.74 203.482 287.93 206.642C288.02 206.562 288.1 206.492 288.19 206.412C290.33 204.272 290.33 200.792 288.19 198.652L288.18 198.642Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M389.05 66.7319C391.2 68.8719 394.67 68.8719 396.81 66.7319C398.25 65.2919 398.71 63.2619 398.22 61.4319C394.74 61.1219 391.25 60.9819 387.76 61.0019C387.07 62.9419 387.49 65.1819 389.04 66.7319H389.05Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M381.29 74.4919C379.15 72.3419 375.68 72.3419 373.53 74.4919C371.39 76.6319 371.39 80.1119 373.53 82.2519C375.67 84.3919 379.15 84.3919 381.29 82.2519C383.43 80.1119 383.43 76.6319 381.29 74.4919Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M365.77 90.012C363.63 87.872 360.16 87.872 358.01 90.012C355.86 92.152 355.86 95.632 358.01 97.772C360.15 99.912 363.63 99.912 365.77 97.772C367.91 95.632 367.91 92.152 365.77 90.012Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M350.25 105.532C348.11 103.392 344.64 103.392 342.49 105.532C340.35 107.672 340.35 111.152 342.49 113.292C344.63 115.432 348.1 115.432 350.25 113.292C352.39 111.152 352.39 107.672 350.25 105.532Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M334.73 121.042C332.59 118.902 329.12 118.902 326.97 121.042C324.83 123.182 324.83 126.662 326.97 128.802C329.11 130.942 332.59 130.942 334.73 128.802C336.87 126.662 336.87 123.182 334.73 121.042Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M319.22 136.562C317.08 134.422 313.61 134.422 311.46 136.562C309.32 138.702 309.32 142.182 311.46 144.322C313.6 146.462 317.08 146.462 319.22 144.322C321.36 142.182 321.36 138.702 319.22 136.562Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M303.69 152.092C301.55 149.952 298.08 149.952 295.93 152.092C293.79 154.232 293.79 157.712 295.93 159.852C298.07 161.992 301.55 161.992 303.69 159.852C305.83 157.712 305.83 154.232 303.69 152.092Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M288.18 167.602C286.22 165.642 283.16 165.482 281.01 167.102C280.97 170.082 281.05 173.072 281.25 176.042C283.38 177.472 286.3 177.242 288.18 175.362C290.32 173.222 290.32 169.742 288.18 167.602Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M358.02 66.7319C360.16 68.8719 363.64 68.8719 365.78 66.7319C366.79 65.7219 367.32 64.4119 367.37 63.0919C363.94 63.7819 360.54 64.6319 357.18 65.6519C357.41 66.0319 357.68 66.4019 358.01 66.7319H358.02Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M350.25 74.4919C348.11 72.3419 344.64 72.3419 342.49 74.4919C340.35 76.6319 340.35 80.1119 342.49 82.2519C344.63 84.3919 348.1 84.3919 350.25 82.2519C352.39 80.1119 352.39 76.6319 350.25 74.4919Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M334.74 90.012C332.6 87.872 329.13 87.872 326.98 90.012C324.84 92.152 324.84 95.632 326.98 97.772C329.12 99.912 332.6 99.912 334.74 97.772C336.88 95.632 336.88 92.152 334.74 90.012Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M319.22 105.532C317.08 103.392 313.61 103.392 311.46 105.532C309.32 107.672 309.32 111.152 311.46 113.292C313.6 115.432 317.08 115.432 319.22 113.292C321.36 111.152 321.36 107.672 319.22 105.532Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M303.69 121.042C301.55 118.902 298.08 118.902 295.93 121.042C293.79 123.182 293.79 126.662 295.93 128.802C298.07 130.942 301.55 130.942 303.69 128.802C305.83 126.662 305.83 123.182 303.69 121.042Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M288.18 144.322C290.32 142.182 290.32 138.702 288.18 136.562C287.61 135.992 286.94 135.582 286.24 135.312C285.12 138.782 284.17 142.302 283.41 145.852C285.1 146.132 286.88 145.622 288.18 144.322Z",
    fill: "#67CFEE"
  }))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M121.43 276.53H119.99C116.84 276.53 114.27 273.96 114.27 270.81V269.37C114.27 266.22 116.84 263.65 119.99 263.65H121.43C124.58 263.65 127.15 266.22 127.15 269.37V270.81C127.15 273.96 124.58 276.53 121.43 276.53ZM94.4999 274.29L94.0099 272.93C92.9299 269.97 89.6299 268.43 86.6799 269.51L85.3199 270C82.3599 271.08 80.8199 274.38 81.8999 277.33L82.3899 278.69C83.4699 281.65 86.7699 283.19 89.7199 282.11L91.0799 281.62C94.0399 280.54 95.5799 277.24 94.4999 274.29ZM65.0099 288.73L64.0799 287.62C62.0599 285.21 58.4299 284.89 56.0199 286.91L54.9099 287.84C52.4999 289.86 52.1799 293.49 54.1999 295.9L55.1299 297.01C57.1499 299.42 60.7799 299.74 63.1899 297.72L64.2999 296.79C66.7099 294.77 67.0299 291.14 65.0099 288.73ZM42.2399 312.39L40.9899 311.67C38.2599 310.1 34.7499 311.04 33.1699 313.76L32.4499 315.01C30.8799 317.74 31.8199 321.25 34.5399 322.83L35.7899 323.55C38.5199 325.12 42.0299 324.18 43.6099 321.46L44.3299 320.21C45.8999 317.48 44.9599 313.97 42.2399 312.39ZM28.9299 342.41L27.5099 342.16C24.4099 341.61 21.4299 343.7 20.8799 346.8L20.6299 348.22C20.0799 351.32 22.1699 354.3 25.2699 354.85L26.6899 355.1C29.7899 355.65 32.7699 353.56 33.3199 350.46L33.5699 349.04C34.1199 345.94 32.0299 342.96 28.9299 342.41ZM26.6899 375.17L25.2699 375.42C22.1699 375.97 20.0799 378.95 20.6299 382.05L20.8799 383.47C21.4299 386.57 24.4099 388.66 27.5099 388.11L28.9299 387.86C32.0299 387.31 34.1199 384.33 33.5699 381.23L33.3199 379.81C32.7699 376.71 29.7899 374.62 26.6899 375.17ZM35.7899 406.72L34.5399 407.44C31.8099 409.01 30.8699 412.53 32.4499 415.26L33.1699 416.51C34.7399 419.24 38.2599 420.18 40.9899 418.6L42.2399 417.88C44.9699 416.31 45.9099 412.79 44.3299 410.06L43.6099 408.81C42.0399 406.08 38.5199 405.14 35.7899 406.72ZM55.1299 433.25L54.1999 434.36C52.1799 436.77 52.4899 440.4 54.9099 442.42L56.0199 443.35C58.4299 445.37 62.0599 445.06 64.0799 442.64L65.0099 441.53C67.0299 439.12 66.7199 435.49 64.2999 433.47L63.1899 432.54C60.7799 430.52 57.1499 430.83 55.1299 433.25ZM82.3799 451.57L81.8899 452.93C80.8099 455.89 82.3499 459.19 85.3099 460.26L86.6699 460.75C89.6299 461.83 92.9299 460.29 93.9999 457.33L94.4899 455.97C95.5699 453.01 94.0299 449.71 91.0699 448.64L89.7099 448.15C86.7499 447.07 83.4499 448.61 82.3799 451.57ZM114.25 459.46V460.9C114.25 464.05 116.82 466.62 119.97 466.62H121.41C124.56 466.62 127.13 464.05 127.13 460.9V459.46C127.13 456.31 124.56 453.74 121.41 453.74H119.97C116.82 453.74 114.25 456.31 114.25 459.46ZM146.9 455.98L147.39 457.34C148.47 460.3 151.77 461.84 154.72 460.76L156.08 460.27C159.04 459.19 160.58 455.89 159.5 452.94L159.01 451.58C157.93 448.62 154.63 447.08 151.68 448.16L150.32 448.65C147.36 449.73 145.82 453.03 146.9 455.98ZM176.39 441.54L177.32 442.65C179.34 445.06 182.97 445.38 185.38 443.36L186.49 442.43C188.9 440.41 189.22 436.78 187.2 434.37L186.27 433.26C184.25 430.85 180.62 430.53 178.21 432.55L177.1 433.48C174.69 435.5 174.37 439.13 176.39 441.54ZM199.16 417.88L200.41 418.6C203.14 420.17 206.65 419.23 208.23 416.51L208.95 415.26C210.52 412.53 209.58 409.02 206.86 407.44L205.61 406.72C202.88 405.15 199.37 406.09 197.79 408.81L197.07 410.06C195.5 412.79 196.44 416.3 199.16 417.88ZM212.47 387.86L213.89 388.11C216.99 388.66 219.97 386.57 220.52 383.47L220.77 382.05C221.32 378.95 219.23 375.97 216.13 375.42L214.71 375.17C211.61 374.62 208.63 376.71 208.08 379.81L207.83 381.23C207.28 384.33 209.37 387.31 212.47 387.86ZM214.71 355.1L216.13 354.85C219.23 354.3 221.32 351.32 220.77 348.22L220.52 346.8C219.97 343.7 216.99 341.61 213.89 342.16L212.47 342.41C209.37 342.96 207.28 345.94 207.83 349.04L208.08 350.46C208.63 353.56 211.61 355.65 214.71 355.1ZM205.61 323.55L206.86 322.83C209.59 321.26 210.53 317.74 208.95 315.01L208.23 313.76C206.66 311.03 203.14 310.09 200.41 311.67L199.16 312.39C196.43 313.96 195.49 317.48 197.07 320.21L197.79 321.46C199.36 324.19 202.88 325.13 205.61 323.55ZM186.27 297.02L187.2 295.91C189.22 293.5 188.91 289.87 186.49 287.85L185.38 286.92C182.97 284.9 179.34 285.21 177.32 287.63L176.39 288.74C174.37 291.15 174.68 294.78 177.1 296.8L178.21 297.73C180.62 299.75 184.25 299.44 186.27 297.02ZM159.02 278.7L159.51 277.34C160.59 274.38 159.05 271.08 156.09 270.01L154.73 269.52C151.77 268.44 148.47 269.98 147.4 272.94L146.91 274.3C145.83 277.26 147.37 280.56 150.33 281.63L151.69 282.12C154.65 283.2 157.95 281.66 159.02 278.7Z",
    fill: "#FFDE00"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M224.13 506.24C237.987 506.24 249.22 495.007 249.22 481.15C249.22 467.293 237.987 456.06 224.13 456.06C210.273 456.06 199.04 467.293 199.04 481.15C199.04 495.007 210.273 506.24 224.13 506.24Z",
    fill: "#67CFEE"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M1214.36 406.602C1225.85 406.602 1235.17 397.285 1235.17 385.792C1235.17 374.299 1225.85 364.982 1214.36 364.982C1202.87 364.982 1193.55 374.299 1193.55 385.792C1193.55 397.285 1202.87 406.602 1214.36 406.602Z",
    fill: "#FFDE00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M1729.35 -28.1381C1734.93 -22.7881 1735.12 -13.9281 1729.77 -8.3481L1229.47 513.662C1224.12 519.242 1215.26 519.432 1209.68 514.082C1204.1 508.732 1203.91 499.872 1209.26 494.292L1709.56 -27.7181C1714.91 -33.2981 1723.77 -33.4881 1729.35 -28.1381Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M1636.24 -354.108C1641.82 -348.758 1642.01 -339.898 1636.66 -334.318L1136.36 187.692C1131.01 193.272 1122.15 193.462 1116.57 188.112C1110.99 182.762 1110.8 173.902 1116.15 168.322L1616.45 -353.688C1621.8 -359.268 1630.66 -359.458 1636.24 -354.108ZM1082.45 224.312C1088.02 229.652 1096.86 229.462 1102.2 223.892C1107.54 218.322 1107.35 209.482 1101.78 204.142C1096.21 198.802 1087.37 198.992 1082.03 204.562C1076.69 210.132 1076.88 218.972 1082.45 224.312Z",
    fill: "#FFDE00"
  }))), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M1651.55 -261.498C1657.13 -256.148 1657.32 -247.288 1651.97 -241.708L1151.67 280.302C1146.32 285.882 1137.46 286.072 1131.88 280.722C1126.3 275.372 1126.11 266.512 1131.46 260.932L1631.76 -261.078C1637.11 -266.658 1645.97 -266.848 1651.55 -261.498ZM1097.76 316.922C1103.33 322.262 1112.17 322.072 1117.51 316.502C1122.85 310.932 1122.66 302.092 1117.09 296.752C1111.52 291.412 1102.68 291.602 1097.34 297.172C1092 302.742 1092.19 311.582 1097.76 316.922Z",
    fill: "#67CFEE"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M914.094 -247.3C919.674 -241.95 919.864 -233.09 914.514 -227.51L414.214 294.5C408.864 300.08 400.004 300.27 394.424 294.92C388.844 289.57 388.654 280.71 394.004 275.13L894.304 -246.88C899.654 -252.46 908.514 -252.65 914.094 -247.3ZM360.304 331.12C365.874 336.46 374.714 336.27 380.054 330.7C385.394 325.13 385.204 316.29 379.634 310.95C374.064 305.61 365.224 305.8 359.884 311.37C354.544 316.94 354.734 325.78 360.304 331.12Z",
    fill: "#FFDE00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M476.419 304.635C465.919 294.565 465.559 277.895 475.629 267.385L1417.04 -714.885C1427.11 -725.385 1443.78 -725.745 1454.29 -715.675C1464.79 -705.605 1465.15 -688.935 1455.08 -678.425L513.659 303.845C503.589 314.345 486.919 314.705 476.409 304.635H476.419Z",
    fill: "#67CFEE"
  }))), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M262.88 236.1C274.29 236.1 283.54 226.85 283.54 215.44C283.54 204.03 274.29 194.78 262.88 194.78C251.47 194.78 242.22 204.03 242.22 215.44C242.22 226.85 251.47 236.1 262.88 236.1Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M183.95 326.22C209.587 326.22 230.37 305.437 230.37 279.8C230.37 254.163 209.587 233.38 183.95 233.38C158.313 233.38 137.53 254.163 137.53 279.8C137.53 305.437 158.313 326.22 183.95 326.22Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M1256.86 135.772H1255.41C1252.25 135.772 1249.69 138.333 1249.69 141.492V142.942C1249.69 146.101 1252.25 148.662 1255.41 148.662H1256.86C1260.02 148.662 1262.58 146.101 1262.58 142.942V141.492C1262.58 138.333 1260.02 135.772 1256.86 135.772Z",
    fill: "#FFDE00"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M1220.78 142.027L1222.14 141.535C1225.11 140.454 1228.39 141.984 1229.47 144.953L1229.96 146.306C1231.04 149.276 1229.51 152.557 1226.54 153.638L1225.19 154.13C1222.22 155.211 1218.94 153.681 1217.86 150.712L1217.36 149.349C1216.28 146.38 1217.81 143.099 1220.78 142.018L1220.78 142.027Z",
    fill: "#FFDE00"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M1191.45 159.02L1190.34 159.952C1187.92 161.982 1187.61 165.59 1189.64 168.01L1190.57 169.121C1192.6 171.541 1196.21 171.857 1198.63 169.826L1199.74 168.894C1202.16 166.863 1202.47 163.256 1200.44 160.836L1199.51 159.725C1197.48 157.305 1193.87 156.989 1191.45 159.02Z",
    fill: "#FFDE00"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.61 185.906L1167.89 187.162C1166.31 189.898 1167.24 193.396 1169.98 194.975L1171.23 195.701C1173.97 197.28 1177.47 196.343 1179.05 193.607L1179.77 192.351C1181.35 189.615 1180.42 186.117 1177.68 184.537L1176.42 183.812C1173.69 182.233 1170.19 183.17 1168.61 185.906Z",
    fill: "#FFDE00"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M1156.34 218.973L1156.09 220.401C1155.54 223.512 1157.62 226.479 1160.73 227.028L1162.16 227.279C1165.27 227.828 1168.24 225.751 1168.79 222.639L1169.04 221.212C1169.59 218.1 1167.51 215.134 1164.4 214.585L1162.97 214.333C1159.86 213.785 1156.89 215.862 1156.34 218.973Z",
    fill: "#FFDE00"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M1156.01 254.133L1156.26 255.561C1156.81 258.672 1159.77 260.75 1162.89 260.201L1164.31 259.949C1167.42 259.401 1169.5 256.434 1168.95 253.323L1168.7 251.895C1168.15 248.784 1165.19 246.707 1162.08 247.255L1160.65 247.507C1157.54 248.055 1155.46 251.022 1156.01 254.133Z",
    fill: "#FFDE00"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M1167.85 287.371L1168.57 288.627C1170.15 291.363 1173.65 292.3 1176.39 290.72L1177.64 289.995C1180.38 288.416 1181.31 284.918 1179.73 282.182L1179.01 280.926C1177.43 278.19 1173.93 277.253 1171.2 278.832L1169.94 279.557C1167.2 281.137 1166.27 284.635 1167.85 287.371Z",
    fill: "#FFDE00"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M1190.36 314.541L1191.47 315.473C1193.89 317.503 1197.5 317.188 1199.53 314.768L1200.46 313.657C1202.49 311.237 1202.18 307.629 1199.76 305.598L1198.65 304.666C1196.23 302.636 1192.62 302.951 1190.59 305.371L1189.66 306.482C1187.63 308.902 1187.94 312.51 1190.36 314.541Z",
    fill: "#FFDE00"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M1220.77 332.383L1222.13 332.879C1225.1 333.959 1228.38 332.429 1229.46 329.46L1229.96 328.098C1231.04 325.129 1229.51 321.847 1226.54 320.766L1225.17 320.27C1222.21 319.19 1218.92 320.72 1217.84 323.689L1217.35 325.052C1216.27 328.02 1217.8 331.302 1220.77 332.383Z",
    fill: "#FFDE00"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M1255.41 338.762H1256.86C1260.02 338.762 1262.58 336.201 1262.58 333.042V331.592C1262.58 328.433 1260.02 325.872 1256.86 325.872H1255.41C1252.25 325.872 1249.69 328.433 1249.69 331.592V333.042C1249.69 336.201 1252.25 338.762 1255.41 338.762Z",
    fill: "#FFDE00"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M1290.18 332.874L1291.54 332.378C1294.51 331.298 1296.04 328.015 1294.96 325.047L1294.46 323.684C1293.38 320.716 1290.1 319.185 1287.13 320.265L1285.77 320.761C1282.8 321.842 1281.27 325.124 1282.35 328.093L1282.84 329.455C1283.92 332.424 1287.21 333.955 1290.18 332.874Z",
    fill: "#FFDE00"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M1320.83 315.437L1321.94 314.505C1324.36 312.475 1324.67 308.867 1322.64 306.447L1321.71 305.336C1319.68 302.916 1316.07 302.6 1313.65 304.631L1312.54 305.563C1310.12 307.594 1309.8 311.201 1311.84 313.621L1312.77 314.732C1314.8 317.152 1318.41 317.468 1320.83 315.437Z",
    fill: "#FFDE00"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M1343.7 288.706L1344.42 287.451C1346 284.715 1345.07 281.217 1342.33 279.637L1341.07 278.912C1338.34 277.333 1334.84 278.27 1333.26 281.006L1332.54 282.261C1330.96 284.997 1331.89 288.496 1334.63 290.075L1335.88 290.8C1338.62 292.38 1342.12 291.442 1343.7 288.706Z",
    fill: "#FFDE00"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M1355.93 255.554L1356.18 254.126C1356.73 251.015 1354.65 248.049 1351.54 247.5L1350.11 247.248C1347 246.7 1344.03 248.777 1343.49 251.888L1343.23 253.316C1342.69 256.427 1344.76 259.394 1347.87 259.942L1349.3 260.194C1352.41 260.743 1355.38 258.665 1355.93 255.554Z",
    fill: "#FFDE00"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M1356.28 220.384L1356.03 218.956C1355.48 215.845 1352.51 213.768 1349.4 214.317L1347.97 214.568C1344.86 215.117 1342.78 218.084 1343.33 221.195L1343.59 222.623C1344.13 225.734 1347.1 227.811 1350.21 227.262L1351.64 227.011C1354.75 226.462 1356.83 223.495 1356.28 220.384Z",
    fill: "#FFDE00"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M1343.6 185.876L1344.32 187.123C1345.9 189.859 1344.96 193.356 1342.23 194.936L1340.98 195.656C1338.24 197.236 1334.74 196.299 1333.16 193.563L1332.44 192.316C1330.86 189.579 1331.8 186.082 1334.54 184.502L1335.79 183.782C1338.52 182.202 1342.02 183.139 1343.6 185.876Z",
    fill: "#FFDE00"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M1321.98 159.966L1320.87 159.034C1318.45 157.004 1314.84 157.319 1312.81 159.739L1311.88 160.85C1309.85 163.27 1310.16 166.878 1312.58 168.909L1313.7 169.841C1316.12 171.871 1319.72 171.556 1321.75 169.136L1322.69 168.025C1324.72 165.605 1324.4 161.997 1321.98 159.966Z",
    fill: "#FFDE00"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M1291.45 142.182L1290.09 141.686C1287.12 140.606 1283.84 142.137 1282.76 145.105L1282.26 146.468C1281.18 149.436 1282.71 152.719 1285.68 153.799L1287.04 154.295C1290.01 155.375 1293.29 153.845 1294.37 150.876L1294.87 149.514C1295.95 146.545 1294.42 143.263 1291.45 142.182Z",
    fill: "#FFDE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopDesktopLandingPage);
export default __webpack_public_path__ + "static/media/topDesktopLandingPage.8f8790819dc9d4cb4f0d3b97222b3748.svg";
export { ForwardRef as ReactComponent };